import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  dataDistribusiException: [],
  dataProgressException: [],
  dataRiskException: [],
  dataRiskEventException: [],
  dataRegionDeposito: [],
  dataObjectCategory: [],
  dataRiskEventObjectCategory: [],
  dataOffice: [],
  dataRiskStatement: [],
  dataArea: [],
  dataRiskEvent: [],
  dataRisk: [],
  keyword: "",
  sortConfig: {
    key: "reportName",
    direction: "ASC",
  },
  loading: false,
};

export const DashboardAdmin = createSlice({
  name: "dashboard_admin",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeDataDistribusiException: (state, action) => {
      state.dataDistribusiException = action.payload;
    },
    ChangeDataProgressException: (state, action) => {
      state.dataProgressException = action.payload;
    },
    ChangeDataRiskException: (state, action) => {
      state.dataRiskException = action.payload;
    },
    ChangeDataRiskEventException: (state, action) => {
      state.dataRiskEventException = action.payload;
    },
    ChangeDataRegionDeposito: (state, action) => {
      state.dataRegionDeposito = action.payload;
    },
    ChangeDataObjectCategory: (state, action) => {
      state.dataObjectCategory = action.payload;
    },
    ChangeDataRiskEventObjectCategory: (state, action) => {
      state.dataRiskEventObjectCategory = action.payload;
    },
    ChangeDataOffice: (state, action) => {
      state.dataOffice = action.payload;
    },
    ChangeDataRiskStatement: (state, action) => {
      state.dataRiskStatement = action.payload;
    },
    ChangeDataArea: (state, action) => {
      state.dataArea = action.payload;
    },
    ChangeDataRiskEvent: (state, action) => {
      state.dataRiskEvent = action.payload;
    },
    ChangeDataRisk: (state, action) => {
      state.dataRisk = action.payload;
    },
    ChangeKeyword: (state, action) => {
      state.keyword = action.payload;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeDataDistribusiException,
  ChangeDataRiskException,
  ChangeDataRiskEventException,
  ChangeDataProgressException,
  ChangeDataRegionDeposito,
  ChangeDataObjectCategory,
  ChangeDataRiskEventObjectCategory,
  ChangeDataOffice,
  ChangeDataRiskStatement,
  ChangeDataArea,
  ChangeDataRiskEvent,
  ChangeDataRisk,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
} = DashboardAdmin.actions;

export default DashboardAdmin.reducer;
